import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 欧美一区二区`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          {article.featured && (
            <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
              精选
            </span>
          )}
          <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-background-950/60 text-background-50 text-xs backdrop-blur-sm">
            {article.readTime} 分钟阅读
          </span>
        </div>
      </Link>

      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${article.categorySlug}`}
            className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
          >
            {article.categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{article.publishedAt}</span>
        </div>

        <Link to={`/article/${article.id}`} className="block">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-4">
            {article.excerpt}
          </p>
        </Link>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-xs text-accent-500"></i>
              <span className="text-xs font-medium text-foreground-700">{article.rating}</span>
            </div>
            <span className="text-foreground-400 mx-1">·</span>
            <div className="flex items-center gap-0.5">
              <i className="ri-eye-line text-xs text-foreground-500"></i>
              <span className="text-xs text-foreground-500">{article.views.toLocaleString()}</span>
            </div>
          </div>
          <Link
            to={`/article/${article.id}`}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}